class FullscreenMenu extends HTMLElement {
  connectedCallback() {
    this.closeButton = this.querySelector('[data-fullscreen-menu-close]');
    this.items = this.querySelectorAll('.fullscreen-menu__item');
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.triggeredBy = null;

    document.querySelectorAll(`[data-fullscreen-menu-open][aria-controls="${this.id}"]`).forEach((trigger) => {
      trigger.addEventListener('click', () => this.open(trigger));
    });

    this.closeButton?.addEventListener('click', () => this.close());
    this.addEventListener('keydown', (event) => this.onKeydown(event));
    this.addEventListener('click', (event) => {
      if (event.target === this) this.close();
    });

    this.trapFocus = this.trapFocus.bind(this);
  }

  open(trigger) {
    this.triggeredBy = trigger;
    this.hidden = false;

    if (!this.reduceMotion) {
      this.items.forEach((item, index) => {
        item.style.transitionDelay = `${index * 0.03}s`;
      });
    }

    // Force a synchronous reflow so the browser commits the display:none -> block
    // change before the opacity transition starts; requestAnimationFrame alone
    // doesn't fire reliably in backgrounded/inactive tabs.
    void this.offsetHeight;
    this.classList.add('is-open');

    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('focus', this.trapFocus, true);
    this.closeButton?.focus();
  }

  close() {
    this.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.removeEventListener('focus', this.trapFocus, true);

    const finish = () => {
      this.hidden = true;
      this.removeEventListener('transitionend', finish);
    };

    if (this.reduceMotion) {
      finish();
    } else {
      this.addEventListener('transitionend', finish);
    }

    this.triggeredBy?.focus();
  }

  onKeydown(event) {
    if (event.key === 'Escape') this.close();
  }

  trapFocus(event) {
    if (this.contains(event.target)) return;
    event.stopPropagation();
    this.closeButton?.focus();
  }
}

customElements.define('fullscreen-menu', FullscreenMenu);
